'use client';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { RADIUS } from 'src/theme/ui-tokens';
import { track } from 'src/lib/analytics/client';


/**
 * 공유 페이지의 **가입 단추 둘** — 「무료로 시작하기」(회원가입) · 「서비스 알아보기」(홈).
 *
 * 🔑 공유 페이지 셋(소재·브랜드·크리에이터)이 같은 두 단추를 쓴다 — 아래 띠(`PublicShareShell`)에 선다.
 * ⚠️ 짙은 띠 위의 채운 단추는 `primary` 다 — 기본(`inherit`)은 짙은 회색이라 띠에 묻힌다.
 * ⚠️ 좁은 폭에서는 둘째 단추가 아랫줄로 접힌다(`flexWrap`) — 한 줄에 우겨넣으면 글자가 눌린다.
 * @param tone `dark` 짙은 띠 위(흰 글자) · `light` 밝은 바탕(기본 색)
 * @param source 누른 자리 — `cta_clicked` 의 `cta_id` 로 남는다(`public_share_signup.<source>`)
 */
export function PublicShareSignupButtons({ tone, source }: { tone: 'dark' | 'light'; source: string }) {
  return (
    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" justifyContent="center" sx={{ pt: 0.5 }}>
      <Button
        component={RouterLink}
        href={paths.auth.register}
        variant="contained"
        color={tone === 'dark' ? 'primary' : 'inherit'}
        size="large"
        onClick={() => track({ name: 'cta_clicked', type: 'action', props: { cta_id: `public_share_signup.${source}`, label: '무료로 시작하기' } }, { uiId: `${source}.share.signup` })}
        sx={{ borderRadius: RADIUS.pill, px: 3 }}
      >
        무료로 시작하기
      </Button>
      <Button
        component={RouterLink}
        href={paths.home.intro}
        variant="outlined"
        size="large"
        sx={
          tone === 'dark'
            ? { borderRadius: RADIUS.pill, px: 3, color: 'common.white', borderColor: 'rgba(255,255,255,0.6)', '&:hover': { borderColor: 'common.white', bgcolor: 'rgba(255,255,255,0.08)' } }
            : { borderRadius: RADIUS.pill, px: 3 }
        }
      >
        서비스 알아보기
      </Button>
    </Stack>
  );
}
